import { render, staticRenderFns } from "./PublicQuotationPages13.vue?vue&type=template&id=4477cca2&scoped=true&"
import script from "./PublicQuotationPages13.vue?vue&type=script&lang=js&"
export * from "./PublicQuotationPages13.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4477cca2",
  null
  
)

export default component.exports